import { FetchErrorWithData } from 'century-core/core-apis/fetch';
import { GET, setUrlSearchParams } from 'century-core/core-apis/utils';
import { PaginatedResult } from 'century-core/core-utils/shared/shared.types';
import { getAssignmentUrl } from './assignmentV1';
import { UserAssignment, UserAssignmentNextNugget, UserCompletedAssignment } from './types';

export function getUserAssignmentNextNugget(token: string, courseId: string, nuggetId: string, signal?: AbortSignal) {
  const url = getAssignmentUrl(`/users/me/courses/${courseId}/nuggets/${nuggetId}/next`);

  return GET<UserAssignmentNextNugget>({ url, token, signal }).catch((err: FetchErrorWithData) => {
    throw Error(`Failed to get user next nugget: ${err.message}`);
  });
}

export function getUserCompletedAssignments(token: string, signal?: AbortSignal) {
  const url = getAssignmentUrl('/users/me/assignments/completed');
  return GET<PaginatedResult<UserCompletedAssignment>>({ url, token, signal });
}

export function getAllUserAssignments(token: string, userId: string, opts: Record<string, string | number>, signal?: AbortSignal) {
  const url = getAssignmentUrl(`/users/${userId}/assignments`);
  setUrlSearchParams(url, opts);
  return GET<PaginatedResult<UserAssignment>>({ url, token, signal }).catch((err: FetchErrorWithData) => {
    throw Error(`Failed to get user assignments: ${err.message}`);
  });
}
